module.exports = __webpack_public_path__ + "img/pending.5002355e.svg";